import { useInteraction } from '@mercadoni/sinister/dist/cjs/monitors'
import { UseListContext } from '@mercadoni/sinister/dist/cjs/shoppingLists'

import useGuessAction from '../../../hooks/useGuessAction'

import { goToPromoTag } from '@/navigation/CSR/goToPromoTag'
import { ProductCtrlsProps, ProductPayload } from '~types/index'

const useProductCtrls = ({
  sendEventSelectProduct,
  router,
}: ProductCtrlsProps) => {
  const { favoriteService } = UseListContext()
  const { sendInteractionEvent } = useInteraction()

  const onCarlessProduct = useGuessAction({ router, forceToLogin: false })
  const onClickProductPromoTag = ({ tag }: ProductPayload) =>
    goToPromoTag(router, tag)

  const onClickProduct = ({ product, category }: ProductPayload) => {
    if (!product) {
      return
    }
    sendEventSelectProduct({ product, category })
  }

  return {
    favoriteService,
    onClickProduct,
    onClickProductPromoTag,
    onCarlessProduct,
    onInteractionProduct: sendInteractionEvent,
  }
}
export default useProductCtrls
